import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useListView} from '../core/ListViewProvider'
import {UserListToolbar} from './UserListToolbar'
import {UsersListGrouping} from './UsersListGrouping'
import {UsersListSearchComponent} from './UsersListSearchComponent'

type RoleOpt = {_id: string; name: string}

type UsersListHeaderProps = {
  filters: {page: number; size: number; status: string; role: string}
  setFilters: React.Dispatch<
    React.SetStateAction<{page: number; size: number; status: string; role: string}>
  >
}

const UsersListHeader = ({filters, setFilters}: UsersListHeaderProps) => {
  const intl = useIntl()
  const {selected} = useListView()
  const [roles, setRoles] = useState<RoleOpt[]>([])

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/roles`, {
          headers: {Authorization: `bearer ${localStorage.getItem('token') || ''}`},
        })
        const data = await res.json()
        const list = Array.isArray(data) ? data : data?.data || []
        setRoles(
          (list as RoleOpt[]).filter(
            (r) => r.name !== 'ROLE_USER' && r.name !== 'ROLE_CLIENT',
          ),
        )
      } catch {
        setRoles([])
      }
    }
    load()
  }, [])

  return (
    <div className='card-header border-0 pt-6 pb-4 flex-wrap gap-3'>
      {/* Filters */}
      <div className='d-flex flex-wrap gap-3 align-items-center flex-grow-1'>
        <UsersListSearchComponent />
        <select
          className='form-select form-select-solid w-auto min-w-125px'
          value={filters.status}
          onChange={(e) => setFilters((f) => ({...f, page: 0, status: e.target.value}))}
        >
          <option value=''>{intl.formatMessage({id: 'USERS.FILTER.ALL_STATUS'})}</option>
          <option value='ACTIVE'>{intl.formatMessage({id: 'USERS.STATUS.ACTIVE'})}</option>
          <option value='INACTIVE'>{intl.formatMessage({id: 'USERS.STATUS.INACTIVE'})}</option>
        </select>
        <select
          className='form-select form-select-solid w-auto min-w-150px'
          value={filters.role}
          onChange={(e) => setFilters((f) => ({...f, page: 0, role: e.target.value}))}
        >
          <option value=''>{intl.formatMessage({id: 'USERS.FILTER.ALL_ROLES'})}</option>
          {roles.map((r) => (
            <option key={r._id} value={r._id}>
              {r.name}
            </option>
          ))}
        </select>
      </div>
      {/* Toolbar */}
      <div className='card-toolbar ms-auto'>
        {selected.length > 0 ? <UsersListGrouping /> : <UserListToolbar filters={filters} />}
      </div>
    </div>
  )
}

export {UsersListHeader}
